var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.3999C6.477 2.3999 2 6.8769 2 12.3999C2 17.9229 6.477 22.3999 12 22.3999C17.523 22.3999 22 17.9229 22 12.3999C22 6.8769 17.523 2.3999 12 2.3999Z",
    fill: "url(#paint0_linear_34401_2326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3535 15.0504H15.9415L16.348 12.4214H13.3535V10.9844C13.3535 9.8924 13.7105 8.9239 14.732 8.9239H16.3735V6.6299C16.085 6.5909 15.475 6.5059 14.3225 6.5059C11.9155 6.5059 10.5045 7.7769 10.5045 10.6729V12.4219H8.03V15.0509H10.504V22.2769C10.994 22.3499 11.4905 22.3999 12 22.3999C12.4605 22.3999 12.91 22.3579 13.3535 22.2979V15.0504Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34401_2326",
    x1: 4.9965,
    y1: 5.3964,
    x2: 20.3075,
    y2: 20.7074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d231979a83a0267fe821cfb3961208ec.svg";
export { ForwardRef as ReactComponent };